"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoveUSManualDataSource = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TradeAPILib_1 = require("TradeAPILib");
const lodash_1 = require("lodash");
const MoveUSTools_1 = require("./MoveUSTools");
const useMoveUSManualDataSource = (tradeAPI, orderWebsocketObserve, isFocused = true) => {
    const [dataSource, setDataSource] = (0, react_1.useState)([]);
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const [wsOrder, setWSOrder] = (0, react_1.useState)();
    const exchange = (0, react_1.useMemo)(() => {
        return tradeAPI === null || tradeAPI === void 0 ? void 0 : tradeAPI.getInnerApiKeyInfo().market;
    }, [tradeAPI]);
    const refreshDataSource = (0, react_1.useCallback)(() => {
        if (!tradeAPI) {
            setError({ code: -1, message: "no trade api" });
            return;
        }
        if (refreshing || isFocused === false) {
            return;
        }
        setRefreshing(true);
        // 美国站支持的交易对
        const $enableSymbols = (0, MoveUSTools_1.USSymbolStringsObservable)();
        const $orders = queryAllRuningManualOrders(tradeAPI).pipe((0, operators_1.catchError)((error) => {
            console.log(error);
            throw error;
        }));
        return (0, rxjs_1.combineLatest)($enableSymbols, $orders)
            .pipe((0, operators_1.map)(([enableSymbols, orders]) => {
            const filterData = orders.filter((order) => {
                // 订单的交易对有不在白名单中的, return true
                const isValid = enableSymbols.some((s) => {
                    return s.symbol === order.symbol;
                });
                return !isValid;
            });
            return filterData;
        }))
            .subscribe({
            next: (res) => {
                setDataSource(res);
                setRefreshing(false);
                setError(undefined);
            },
            error: (error) => {
                setDataSource([]);
                setRefreshing(false);
                setError(error);
            }
        });
    }, [refreshing, tradeAPI, isFocused]);
    // 默认请求data source
    (0, react_1.useEffect)(() => {
        if (!isFocused) {
            return;
        }
        const sub = refreshDataSource();
        return () => {
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tradeAPI, isFocused]);
    // 监听websocket
    (0, react_1.useEffect)(() => {
        if (!exchange || !isFocused || !orderWebsocketObserve) {
            return;
        }
        const sub = orderWebsocketObserve().subscribe({
            next: (res) => {
                setWSOrder(res);
            },
            error: (error) => { }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [orderWebsocketObserve, exchange, isFocused]);
    // 合并websocket数据
    (0, react_1.useEffect)(() => {
        if (!wsOrder || refreshing) {
            return;
        }
        let changed = false;
        for (let i = 0; i < dataSource.length; i++) {
            const order = dataSource[i];
            if (order.id !== (wsOrder === null || wsOrder === void 0 ? void 0 : wsOrder.id)) {
                continue;
            }
            const newOrder = TradeAPILib_1.TradeUtils.convertToExchangeOrder((0, lodash_1.merge)(order.originOrderData, wsOrder.originOrderData));
            if (newOrder === null || newOrder === void 0 ? void 0 : newOrder.isRunning) {
                dataSource.splice(i, 1, newOrder);
            }
            else {
                dataSource.splice(i, 1);
            }
            changed = true;
            break;
        }
        changed && setDataSource(new Array().concat(dataSource));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wsOrder, refreshing]);
    return {
        dataSource: dataSource,
        refreshing: refreshing,
        error: error,
        refreshListFunc: refreshDataSource,
    };
};
exports.useMoveUSManualDataSource = useMoveUSManualDataSource;
const queryAllRuningManualOrders = (tradeAPI) => {
    return tradeAPI.queryCustomOrderPage({ limit: 1000, is_manual: true, includeStrategy: false }, true, false);
};
